import React from 'react';
import SarasSlider2 from '../../input/slider/SarasSlider2'

const FormSlider = (props) => {
  const { formObject, action, rowKey, headerKey, ...restProps } = props

  const viewData = formObject.getFormData(rowKey, headerKey, action.paramName);
  const hide = formObject.getValueFromKey(viewData, "dataList.isHid", "0");

  //create object for slider 
  const createValObj = (stepList) => {
    let datalist = [], max, selected;
    if (stepList && Array.isArray(stepList)) {
      max = stepList.length - 1;
      stepList.forEach((step) => {
        let stepObj = {}
        if (viewData.val === step.value)
          selected = step.Priority_Order - 1
        stepObj.value = step.Priority_Order - 1;
        stepObj.lbl = step.Short_Name || step.label;
        stepObj.val = step.value;
        stepObj.valF = step.label;
        stepObj.valS = step.Short_Name|| step.label;
        stepObj.class = step.Class_Name;
        stepObj.style = step.Style;
        datalist[step.Priority_Order - 1] = { ...stepObj };

      })
    }
    return { datalist, max, selected }
  }

  //create response object with datalist
  const createSelectedValObj = (value) => {
    return {
      key: value.val, text: value.valF,
      dataList: {
        valS: value.valS,
        colCssClass: value.class,
        colCssStyle: value.style
      }
    }
  }

  const onChange = (e, value) => {
    // console.log("form input changed", e, action, value);

    if (formObject.onFormValueChange) formObject.onFormValueChange(action, rowKey, headerKey, createSelectedValObj(value));

    //send the parameters reqired by the form
    if (action.actionId) formObject.onFormAction(action, rowKey, headerKey);
  }

  if (viewData && hide === "0"){
    const sliderVals = createValObj(action.datalist);

    return (
        <SarasSlider2 datalist={sliderVals.datalist} value={sliderVals.selected} min={0} max={sliderVals.max}  {...restProps} onChange={onChange} />
    )
  }

  return (null);
}

export default FormSlider